/* BiteOn — мінімальна сума замовлення
 * Блокує оформлення, доки сума кошика менша за MIN_TOTAL.
 * Нічого не підміняє в браузері: ні fetch, ні XMLHttpRequest.
 * Підключення: один рядок у layout/theme.liquid перед </body>:
 *   <script src="{{ 'min-order.js' | asset_url }}" defer></script>
 */
(function () {
  'use strict';

  var CONFIG = {
    MIN_TOTAL: 30000,                 // у копійках: 30000 = 300 ₴
    TEXT: {
      notice: 'Мінімальна сума замовлення - {min}. Додайте товарів ще на {left}, щоб оформити замовлення.'
    },
    MONEY: { symbol: '₴', before: false, decimals: 0 },
    NOTICE_CLASS: 'biteon-min-order',
    DEBUG: false
  };

  // Кнопки й посилання, які ведуть на оформлення
  var BTN = [
    '[name="checkout"]',
    '[name="Checkout"]',
    '.cart__checkout',
    '[data-checkout-button]',
    '[href="/checkout"]',
    '[href^="/checkout?"]',
    '[id*="checkout" i]',
    '[class*="checkout-btn" i]',
    '[class*="checkout-button" i]',
    '[class*="btn-checkout" i]'
  ].join(',');

  var state = { total: null, lastFetch: 0, busy: false };

  function log() {
    if (CONFIG.DEBUG && window.console) console.log.apply(console, ['[min-order]'].concat([].slice.call(arguments)));
  }

  function money(cents) {
    var v = (cents / 100).toFixed(CONFIG.MONEY.decimals);
    v = v.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return CONFIG.MONEY.before ? CONFIG.MONEY.symbol + v : v + ' ' + CONFIG.MONEY.symbol;
  }

  function styles() {
    if (document.getElementById('biteon-min-order-css')) return;
    var el = document.createElement('style');
    el.id = 'biteon-min-order-css';
    el.appendChild(document.createTextNode(
      '.' + CONFIG.NOTICE_CLASS + '{display:block;margin:12px 0;padding:12px 14px;border-radius:6px;' +
      'background:#fdecec;color:#c0282d;font-size:14px;line-height:1.45;text-align:left}' +
      '.' + CONFIG.NOTICE_CLASS + ' b{font-weight:700;white-space:nowrap}' +
      '[data-min-order-blocked]{opacity:.45;pointer-events:none;cursor:not-allowed}'
    ));
    (document.head || document.documentElement).appendChild(el);
  }

  function notice(left) {
    var el = document.createElement('div');
    el.className = CONFIG.NOTICE_CLASS;
    el.setAttribute('role', 'status');
    el.innerHTML = CONFIG.TEXT.notice
      .replace('{min}', '<b>' + money(CONFIG.MIN_TOTAL) + '</b>')
      .replace('{left}', '<b>' + money(left) + '</b>');
    return el;
  }

  function targets() {
    var out = [];
    try {
      var nodes = document.querySelectorAll(BTN);
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (n.getAttribute && n.getAttribute('name') === 'add') continue;
        if (n.closest && n.closest('.' + CONFIG.NOTICE_CLASS)) continue;
        out.push(n);
      }
    } catch (e) { log('targets', e); }
    return out;
  }

  function clear() {
    var old = document.querySelectorAll('.' + CONFIG.NOTICE_CLASS);
    for (var i = 0; i < old.length; i++) {
      if (old[i].parentNode) old[i].parentNode.removeChild(old[i]);
    }
    var b = document.querySelectorAll('[data-min-order-blocked]');
    for (var j = 0; j < b.length; j++) {
      b[j].removeAttribute('data-min-order-blocked');
      b[j].removeAttribute('aria-disabled');
      if ('disabled' in b[j]) b[j].disabled = false;
    }
  }

  function apply() {
    if (state.total === null) return;
    var left = CONFIG.MIN_TOTAL - state.total;

    if (!(state.total > 0 && left > 0)) { clear(); return; }

    var list = targets();
    if (!list.length) return;

    clear();

    var hosts = [];
    for (var i = 0; i < list.length; i++) {
      var n = list[i];
      n.setAttribute('data-min-order-blocked', '');
      n.setAttribute('aria-disabled', 'true');
      if ('disabled' in n) n.disabled = true;

      var host = (n.closest && n.closest('form')) || n.parentNode;
      if (!host || hosts.indexOf(host) !== -1) continue;
      hosts.push(host);
      try { n.parentNode.insertBefore(notice(left), n); } catch (e) { log('insert', e); }
    }
    log('blocked, left', left);
  }

  function refresh(force) {
    var now = Date.now();
    if (state.busy) return;
    if (!force && now - state.lastFetch < 800) return;
    state.busy = true;
    state.lastFetch = now;

    var done = function (total) {
      state.busy = false;
      if (typeof total === 'number') { state.total = total; apply(); }
    };

    try {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', '/cart.js', true);
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.onload = function () {
        var t = null;
        try { t = JSON.parse(xhr.responseText).total_price; } catch (e) { log('parse', e); }
        done(t);
      };
      xhr.onerror = function () { done(null); };
      xhr.send();
    } catch (e) { log('xhr', e); state.busy = false; }
  }

  var timer = null;
  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(function () { refresh(true); }, delay || 350);
  }

  function hook() {
    // Клік по будь-чому, що може змінити кошик
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-min-order-blocked]')) { e.preventDefault(); e.stopPropagation(); return; }
      if (t.closest('[name="add"],[type="submit"],[class*="cart" i],[class*="quantity" i],a[href*="/cart"]')) {
        schedule(700);
      }
    }, true);

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('[class*="quantity" i],[name*="quantity" i]')) schedule(700);
    }, true);

    // Події кошика, які розсилають теми та застосунки
    ['cart:updated', 'cart:build', 'cart:refresh', 'cart:change', 'on:cart:add', 'on:cart:update', 'ajaxCart.afterCartLoad']
      .forEach(function (name) {
        document.addEventListener(name, function () { schedule(200); });
      });

    window.addEventListener('pageshow', function () { schedule(100); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) schedule(200); });

    // Перемальовування кошика-шторки темою
    try {
      var mo = new MutationObserver(function () {
        if (state.total === null) return;
        var left = CONFIG.MIN_TOTAL - state.total;
        var blockedNow = document.querySelector('[data-min-order-blocked]');
        if (state.total > 0 && left > 0 && !blockedNow && targets().length) apply();
      });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) { log('observer', e); }
  }

  function start() {
    if (!document.body) { setTimeout(start, 50); return; }
    try {
      styles();
      hook();
      refresh(true);
    } catch (e) { log('start', e); }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();